// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__ClassifierCard from "./ClassifierCard.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function ClassifiersList(Props) {
  let cards = Props.cards;
  return JsxRuntime.jsx("div", {
    children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, card) {
      const Key = String(i);
      return JsxRuntime.jsx(Buhta_landing__ClassifierCard.make, {
        card: card
      }, Key);
    }), cards)),
    className: "flex gap-x-30 gap-y-10 flex-wrap justify-center lg:justify-start"
  });
}

const make = ClassifiersList;

export {
  make,
}
/* Buhta_landing__ClassifierCard Not a pure module */
